/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { 
  FiBookOpen, 
  FiCheckCircle,
  FiXCircle,
  FiClock,
  FiActivity,
  FiBarChart2,
  FiRefreshCw
} from "react-icons/fi";
import { MdOutlineBlock } from "react-icons/md";
import ContentTable from "./Table/ContentTable";
import ContentViewModal from "./Content View/ContentViewModal";
import { getAllCourseList, updateCourseStatus } from "../../Redux/contentSlice";
import Loader from "../../components/Loader/Loader";
import { toast } from "react-toastify";
import { actionByAdminOnCourseBook } from "../../Redux/communitySlice";
import ConfirmToggleModal from "../Session Mangment/Modal/ConfirmToggleModal";

// Helper function to truncate text
const truncateText = (text, maxLength = 20) => {
  if (!text) return "N/A";
  return text.length > maxLength ? `${text.substring(0, maxLength)}...` : text;
};

function Contentmanagement() {
  const dispatch = useDispatch();
  const selector = useSelector((state) => state);
  const {
    contentSlice: { content = [], totalContent = null, loading },
  } = selector || {};
  const [size] = useState(10);
  const [pageNo, setPageNo] = useState(1);
  const [offset, setOffset] = useState(0);
  const [keyword, setkeyword] = useState("");
  const [active, setactive] = useState("");
  const [isMenu, setIsMenu] = useState(false);
  const [clickedUserId, setClickedUserId] = useState(null);
  const [isViewModal, setIsViewModal] = useState(false);
  const [isActionModal, setStatusActionModal] = useState(false);
  const [contentValue, setContentValue] = useState({
    comments: "",
  });
  const [blockReason, setBlockReason] = useState("");

  const [adminToggleData, setAdminToggleData] = useState({
    isOpen: false,
    data: null,
  });
  const [isActionLoading, setIsActionLoading] = useState(false);
  const [isRefresh, setIsRefresh] = useState(false);

  const [sortKey, setSortKey] = useState("createdAt");
  const [sortOrder, setSortOrder] = useState("desc");

  const handleSort = (key) => {
    if (sortKey === key) {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortKey(key);
      setSortOrder("asc");
    }
    setPageNo(1);
  };

  const TbaleHeader = [
    { label: "#", sortKey: null },
    { label: "Course id", sortKey: null },
    { label: "Title", sortKey: "title" },
    { label: "Uploaded By", sortKey: null },
    { label: "Status", sortKey: "isDisable" },
    { label: "Admin Status", sortKey: "isDisableByAdmin" },
    { label: "Upload Date", sortKey: "createdAt" },
    { label: "Action", sortKey: null },
  ];

  // Fetch courses function
  const fetchCourses = () => {
    const credApi = {
      keyWord: keyword,
      fromDate: "",
      toDate: "",
      pageNo: pageNo,
      size: size,
      sortKey: sortKey,
      sortOrder: sortOrder,
      userId: "",
      disable_type: active,
    };
    dispatch(getAllCourseList(credApi));
  };

  useEffect(() => {
    fetchCourses();
  }, [keyword, active, isRefresh, pageNo, size, sortKey, sortOrder]);

  const showMenu = (userId) => {
    if (clickedUserId === userId) {
      setIsMenu(!isMenu);
    } else {
      setClickedUserId(userId);
      setIsMenu(true);
    }
  };

  const viewAction = (data) => {
    setIsViewModal(!isViewModal);
    setContentValue({
      ...data,
      comments: "",
    });
  };

  const handleOnChange = (e) => {
    const { name, value } = e.target;
    setContentValue({ ...contentValue, [name]: value });
  };

  const toggleViewModal = () => {
    setIsViewModal(!isViewModal);
    setContentValue(null);
  };

  const removeContent = (data) => {
    setStatusActionModal(!isActionModal);
    setClickedUserId(data);
  };

  const toggleStatusModal = () => {
    setStatusActionModal(!isActionModal);
    setClickedUserId(null);
    setBlockReason("");
    setContentValue(null);
  };

  // Handle status update (Enable/Disable)
  const handleSubmit = async (e) => {
    // If e is an event, it means it was called from the modal button
    // If e is a course object, it was called from the status badge click
    const courseData = e?.target ? clickedUserId : e;
    const targetCourse = courseData || clickedUserId;
    
    if (!targetCourse) return;

    try {
      setIsActionLoading(true);

      const payLoad = {
        courseId: targetCourse?._id,
        blockReason: blockReason,
        blockComment: contentValue?.comments,
        isDisable: !targetCourse?.isDisable // Toggle the status
      };

      const credApi = {
        keyWord: keyword,
        fromDate: "",
        toDate: "",
        pageNo: pageNo,
        size: size,
        userId: "",
        disable_type: active,
      };

      const response = await dispatch(updateCourseStatus({ 
        Payload: payLoad, 
        forReferesh: credApi 
      }));

      if (response?.payload?.code === 200) {
        toast.success(`Course ${payLoad.isDisable ? 'deactivated' : 'activated'} successfully!`);
        setStatusActionModal(false);
        setClickedUserId(null);
        setBlockReason("");
        setContentValue(null);
        // Refresh the list
        fetchCourses();
        setIsRefresh(!isRefresh);
      } else {
        toast.error(response?.payload?.message || "Failed to update status.");
      }
    } catch (error) {
      console.error("Status update error:", error);
      toast.error("Oops! Something went wrong. Please try again.");
    } finally {
      setIsActionLoading(false);
    }
  };

  const handlePageClick = (data) => {
    const newPageNo = data.selected + 1;
    let offset = Math.ceil(data.selected * size);
    setOffset(offset);
    setPageNo(newPageNo);

    const credApi = {
      keyWord: keyword,
      fromDate: "",
      toDate: "",
      sortKey: sortKey,
      sortOrder: sortOrder,
      pageNo: String(data.selected + 1),
      size: String(size),
      userId: "",
      disable_type: active,
    };
    dispatch(getAllCourseList(credApi));
  };

  const handleConfirmToggle = async () => {
    try {
      setIsActionLoading(true);
      const response = await dispatch(
        actionByAdminOnCourseBook({
          id: adminToggleData?.data?.id,
          isDisableByAdmin: adminToggleData?.data?.isDisableByAdmin,
        }),
      );

      if (response?.payload?.code === 200) {
        toast.success("Status updated successfully");
        fetchCourses();
        setIsRefresh(!isRefresh);
      } else {
        toast.error(response?.payload?.message || "Failed to update status.");
      }
    } catch (error) {
      console.error(error);
      toast.error(
        error?.message || "Oops! Something went wrong. Please try again.",
      );
    } finally {
      setIsActionLoading(false);
      setAdminToggleData({ isOpen: false, data: null });
    }
  };

  // Course statistics - ensure content is an array
  const courseList = Array.isArray(content) ? content : [];
  const totalCourses = totalContent || 0;
  const activeCourses = courseList.filter(c => c.isDisable === false)?.length || 0;
  const inactiveCourses = courseList.filter(c => c.isDisable === true)?.length || 0;
  const pendingCourses = courseList.filter(c => c.status === 'pending')?.length || 0;

  return (
    <>
      <Loader loading={loading || isActionLoading} />

      <div className="min-h-screen bg-gray-50">
        {/* Header Banner */}
        <div className="bg-gradient-to-r from-[#855DF6] via-[#7B5CF6] to-[#715EFE] shadow-lg relative overflow-hidden">
          {/* Decorative elements */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full -mr-20 -mt-20"></div>
          <div className="absolute bottom-0 left-0 w-48 h-48 bg-white/5 rounded-full -ml-12 -mb-12"></div>
          <div className="absolute top-1/2 left-1/2 w-96 h-96 bg-white/5 rounded-full -translate-x-1/2 -translate-y-1/2"></div>
          
          <div className="relative z-10 px-4 md:px-7 py-4 md:py-6">
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
              <div className="flex items-center gap-3">
                <div className="p-2 bg-white/20 rounded-lg backdrop-blur-sm">
                  <FiBookOpen className="w-5 h-5 text-white md:w-6 md:h-6" />
                </div>
                <div>
                  <h2 className="text-xl font-bold text-white md:text-2xl dahboardFont">Course Management</h2>
                  <p className="text-sm text-white/70 hidden sm:block">Manage and moderate all courses on the platform</p>
                </div>
              </div>
              {/* <div className="flex items-center gap-2">
                <button
                  onClick={() => {
                    setIsRefresh(!isRefresh);
                    fetchCourses();
                  }}
                  className="px-3 py-1 text-xs text-white bg-white/20 rounded-full backdrop-blur-sm hover:bg-white/30 transition-colors duration-200"
                >
                  <FiRefreshCw className="inline w-3 h-3 mr-1" />
                  Refresh
                </button>
              </div> */}
            </div>

            {/* Stats Cards */}
            <div className="grid grid-cols-2 gap-3 mt-4 sm:grid-cols-4 md:gap-4">
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-3 md:p-4 border border-white/20 hover:bg-white/20 transition-all duration-300">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-lg font-bold text-white uppercase md:text-lg">Total Courses</p>
                    <p className="text-lg font-bold text-white md:text-2xl">{totalCourses}</p>
                  </div>
                  <div className="p-2 bg-blue-500/30 rounded-lg">
                    <FiBarChart2 className="w-4 h-4 text-white md:w-5 md:h-5" />
                  </div>
                </div>
              </div>
              {/* <div className="bg-white/10 backdrop-blur-sm rounded-xl p-3 md:p-4 border border-white/20 hover:bg-white/20 transition-all duration-300">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-xs font-medium text-white/70 uppercase tracking-wider">Active</p>
                    <p className="text-lg font-bold text-emerald-300 md:text-2xl">{activeCourses}</p>
                  </div>
                  <div className="p-2 bg-emerald-500/30 rounded-lg">
                    <FiCheckCircle className="w-4 h-4 text-emerald-300 md:w-5 md:h-5" />
                  </div>
                </div>
              </div> */}
              {/* <div className="bg-white/10 backdrop-blur-sm rounded-xl p-3 md:p-4 border border-white/20 hover:bg-white/20 transition-all duration-300">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-xs font-medium text-white/70 uppercase tracking-wider">Inactive</p>
                    <p className="text-lg font-bold text-rose-300 md:text-2xl">{inactiveCourses}</p>
                  </div>
                  <div className="p-2 bg-rose-500/30 rounded-lg">
                    <FiXCircle className="w-4 h-4 text-rose-300 md:w-5 md:h-5" />
                  </div>
                </div>
              </div> */}
              {/* <div className="bg-white/10 backdrop-blur-sm rounded-xl p-3 md:p-4 border border-white/20 hover:bg-white/20 transition-all duration-300">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-xs font-medium text-white/70 uppercase tracking-wider">Pending Review</p>
                    <p className="text-lg font-bold text-amber-300 md:text-2xl">{pendingCourses}</p>
                  </div>
                  <div className="p-2 bg-amber-500/30 rounded-lg">
                    <FiClock className="w-4 h-4 text-amber-300 md:w-5 md:h-5" />
                  </div>
                </div>
              </div> */}
            </div>
          </div>
        </div>

        {/* Table Section */}
        <section className="px-3 py-4 -mt-4 md:px-6 lg:px-10 md:py-6">
          <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
            <div className="p-3 md:p-4">
              <ContentTable
                TbaleName="Course Review Table"
                TbaleHeader={TbaleHeader}
                TbaleData={courseList}
                showMenu={showMenu}
                isMenu={isMenu}
                clickedUserId={clickedUserId}
                viewAction={viewAction}
                removeContent={removeContent}
                size={size}
                total={totalContent}
                handlePageClick={handlePageClick}
                offset={offset}
                keyword={keyword}
                setkeyword={setkeyword}
                setactive={setactive}
                active={active}
                handleSubmit={handleSubmit}
                setAdminToggleData={setAdminToggleData}
                currentSortKey={sortKey}
                currentSortOrder={sortOrder}
                onSort={handleSort}
                loading={loading}
              />
            </div>
          </div>
        </section>
      </div>

      {/* Modals */}
      {isViewModal && (
        <ContentViewModal
          isOpen={isViewModal}
          onCancel={toggleViewModal}
          inputValue={contentValue}
          title={`Preview Course`}
          handleOnChange={handleOnChange}
          onSubmit={handleSubmit}
        />
      )}
      
      {isActionModal && (
        <DisableEnableModal
          isOpen={isActionModal}
          title={`Update Status`}
          description={`Are you sure you want to ${clickedUserId?.isDisable ? 'activate' : 'inactivate'} this course?`}
          onDelete={() => handleSubmit(clickedUserId)}
          onCancel={toggleStatusModal}
          buttonName={clickedUserId?.isDisable ? "Activate" : "Inactivate"}
          data={clickedUserId}
        />
      )}
      
      {adminToggleData.isOpen && (
        <ConfirmToggleModal
          isOpen={adminToggleData.isOpen}
          isDisable={adminToggleData.data?.isDisableByAdmin}
          onCancel={() => setAdminToggleData({ isOpen: false, data: null })}
          onConfirm={handleConfirmToggle}
        />
      )}
    </>
  );
}

export default Contentmanagement;

// Enhanced DisableEnableModal Component
const DisableEnableModal = ({
  isOpen,
  title = "Are you sure ?",
  description = "That action cannot be reversed.",
  onDelete,
  onCancel,
  buttonName = "Delete",
  icon,
  data,
}) => {
  if (!isOpen) return null;

  const isActive = !data?.isDisable;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm animate-in fade-in duration-200">
      <div className="bg-white rounded-2xl shadow-2xl w-[90%] max-w-md p-6 animate-in zoom-in-95 duration-200">
        {/* Header */}
        <div className="flex items-center justify-between pb-4 border-b border-gray-100">
          <div className="flex items-center gap-3">
            {isActive ? (
              <div className="p-2 bg-emerald-50 rounded-full">
                <FiCheckCircle className="w-6 h-6 text-emerald-500" />
              </div>
            ) : (
              <div className="p-2 bg-rose-50 rounded-full">
                <MdOutlineBlock className="w-6 h-6 text-rose-500" />
              </div>
            )}
            <h3 className="text-lg font-semibold text-gray-800">
              {isActive ? 'Active Course' : 'Inactive Course'}
            </h3>
          </div>
          <button
            className="flex items-center justify-center w-8 h-8 text-gray-400 transition-colors rounded-full hover:bg-gray-100 hover:text-gray-600"
            onClick={onCancel}
          >
            <FiXCircle className="w-5 h-5" />
          </button>
        </div>

        {/* Body */}
        <div className="py-6 text-center">
          <div className="mb-4">
            <p className="text-gray-700 text-base">
              {isActive ? (
                <>
                  Are you sure you want to <span className="font-semibold text-rose-600">deactivate</span>
                </>
              ) : (
                <>
                  Are you sure you want to <span className="font-semibold text-emerald-600">activate</span>
                </>
              )}
              <span className="ml-1 font-semibold text-gray-900">"{data?.title || 'this course'}"</span>
            </p>
            <p className="mt-1 text-sm text-gray-500">
              {isActive 
                ? 'This course will be hidden from users.' 
                : 'This course will be visible to all users.'}
            </p>
          </div>
        </div>

        {/* Footer */}
        <div className="flex justify-center gap-3 pt-4 border-t border-gray-100">
          <button
            className="px-6 py-2.5 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors duration-200"
            onClick={onCancel}
          >
            Cancel
          </button>
          <button
            className={`
              px-6 py-2.5 text-sm font-medium text-white rounded-lg transition-colors duration-200
              ${isActive 
                ? 'bg-rose-600 hover:bg-rose-700 shadow-lg shadow-rose-500/25' 
                : 'bg-emerald-600 hover:bg-emerald-700 shadow-lg shadow-emerald-500/25'
              }
            `}
            onClick={onDelete}
          >
            {isActive ? 'Deactivate' : 'Activate'}
          </button>
        </div>
      </div>
    </div>
  );
};